import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import firebase from "../../fire";
import PageTitle from "../../components/common/PageTitle";
import { Link } from "react-router-dom";
import moment from "moment";
import Skeleton from "@material-ui/lab/Skeleton";
const UsersView = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentDate = moment().format("MMM DD YYYY hh:mm:ss a");

  useEffect(() => {
    // setLoading(true);
    let vid = [];
    getVideos().then(function (result) {
      result.forEach((data) => {
        // setLoading(false);
        vid.push(data);
      });
      setVideos(vid);
    });
  }, [videos]);

  async function getVideos() {
    const db = firebase.firestore();
    const snapshot = await db.collection("videos").get();
    return snapshot.docs.map((doc) => doc.data());
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="" subtitle="TV" className="text-sm-left" />
      </Row>

      {/* Default Light Table */}
      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">All TV</h6>
              <Link
                className={"btn btn-primary btn-sm float-left"}
                to="/create-video"
              >
                Create
              </Link>
            </CardHeader>

            <CardBody className="p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                      Name
                    </th>
                    <th scope="col" className="border-0">
                      Start date
                    </th>
                    <th scope="col" className="border-0">
                      End date
                    </th>
                    <th scope="col" className="border-0">
                      Watching
                    </th>
                    <th scope="col" className="border-0">
                      Reward
                    </th>
                    <th scope="col" className="border-0">
                      Link
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? videos &&
                      videos.map((i, index) => (
                        <tr key={index}>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                          <td>
                            <Skeleton className="py-3" />
                          </td>
                        </tr>
                      ))
                    : videos &&
                      videos.reverse().map((i, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-capitalize">
                            {i.name}
                            {currentDate >=
                              moment(i?.start_date).format(
                                "MMM DD YYYY hh:mm:ss a"
                              ) &&
                            currentDate <
                              moment(i?.end_date).format(
                                "MMM DD YYYY hh:mm:ss a"
                              ) ? (
                              <div className="text-danger font-weight-bold">
                                live
                              </div>
                            ) : null}
                          </td>
                          <td>{i.start_date}</td>
                          <td>{i.end_date}</td>
                          <td>{i?.live_view?.length}</td>
                          <td>{i.reward}</td>
                          <td>
                            <a target="_blank" href={i.file_name}>
                              Link
                            </a>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UsersView;
